export enum RECORD_TYPE {
	ORDER = "ORDER",
	NOTIFICATION = "NOTIFICATION",
	UPDATE_AVAILABLE = "UPDATE_AVAILABLE",
	UPDATE_INSTALLED = "UPDATE_INSTALLED",
}

export const isRingableOperationalRecord = ({
	type,
	pathname,
	isKdsEnabled,
}: {
	type: RECORD_TYPE;
	pathname: string;
	isKdsEnabled: boolean;
}) =>
	type !== RECORD_TYPE.UPDATE_AVAILABLE &&
	type !== RECORD_TYPE.UPDATE_INSTALLED &&
	!(
		pathname === "/ops/prep-stations" &&
		isKdsEnabled &&
		type === RECORD_TYPE.ORDER
	);
